module.exports = __webpack_public_path__ + "img/graphic_designer_1_splash.5b4fe222.jpg";